import styled from '@emotion/styled';

export const Wrapper = styled('div')`
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .children {
    padding: 0 1.5rem;
  }
`;
